let testOrigin = null;
let allowedOrigins = ['localhost', 'qa.solar', 'my.solarstaff.com'];
try {
  testOrigin =
    (window.parent &&
      window.parent.location &&
      window.parent.location.origin) ||
    null;
} catch (error) {
  console.error("Origin error: ", error);
}

let origin = null;

if (window.isIframe && testOrigin) {
  const isAllowedOrigin = allowedOrigins.some(allowedOrigin => testOrigin.endsWith(allowedOrigin));
  origin = isAllowedOrigin ? testOrigin : null;
}

function sendIframeMessage(type, payload) {
  if (!window.isIframe || !origin) {
    console.error("Wrong iframe data, event: ", type);
    return;
  }

  const message = { type, isIframeFixMessage: true };
  if (payload !== undefined) {
    message.payload = payload;
  }

  window.parent.postMessage(message, origin);
}
window.sendIframeMessage = sendIframeMessage;

function addIsIframeToUrl(url) {
  const urlObj = new URL(url);
  urlObj.searchParams.set("is_iframe", "true");
  return urlObj.toString();
}

function handleLinkClick(event) {
  if (event.defaultPrevented) {
    return;
  }

  const link = event.target;
  if (link.tagName === "A" && link.href) {
    
    if($(link).hasClass("sort-link") ||  link.getAttribute('href') === "#"){
      return;
    }

    const currentURL = new URL(window.location.href);
    const targetURL = new URL(link.href);

    const isHostnameChanged = currentURL.hostname !== targetURL.hostname;

    if (isHostnameChanged) {
      return;
    }
    const pathAndSearch =
      targetURL.pathname + targetURL.search + targetURL.hash;
    sendIframeMessage("navigationChange", pathAndSearch.replace(/^\//, "").replace("?is_iframe=true", "").replace("&is_iframe=true", ""));
    event.preventDefault();
  }
}

function handleButtonClick(event) {
  const button = event.target;
  if (button.type === "submit" && button.formAction) {
    const form = button.form;
    if (form) {
      form.action = addIsIframeToUrl(button.formAction);
    }
  }
}

function handleFormSubmit(event) {
  const form = event.target;
  if (form.action) {
    form.action = addIsIframeToUrl(form.action);
  }
}

if (window.isIframe) {
  sendIframeMessage("isUnauthorizedLayout", window.isUnauthorizedLayout);
  sendIframeMessage("currentUrl", window.location.href);

  $(document).ready(() => {
    $("body").on('shown.bs.modal hidden.bs.modal', (event) => {
      if (event.type === 'shown' && $('.modal-backdrop').length > 0) {
        sendIframeMessage("modalShow")
      }

      if (event.type === 'hidden') {
        sendIframeMessage("modalHide")
      }
    });

    addEventListener("message", (event) => {
      if (
        event.data &&
        event.data.type &&
        event.data.type === "backdropClick"
      ) {
        $(".modal").modal("hide");
      }
    });

    $("body")
      .on("click", "a", handleLinkClick)
      .on("click", "button", handleButtonClick)
      .on("submit", "form", handleFormSubmit);
  });
}
